<script>
    /**
 *
 *
 */

    let { discountValue } = $props();
</script>

{#if discountValue}
    <div class="oc-mt-25">
        <oc-tag-v1 class=" reco_cinema__discount_tag" size="50" variant="sale" data-testid="discount-value">
            {discountValue}
        </oc-tag-v1>
    </div>
{/if}

<style lang="scss">
    .reco_cinema__discount_tag {
        margin-right: 4px;
    }
</style>
